import React, { createContext, useContext, useState, useEffect } from 'react';

const THEME_KEY = 'theme';

const ThemeContext = createContext({ theme: 'light', setTheme: () => {} });

export const ThemeProvider = ({ children }) => {
  const [theme, setThemeState] = useState(() => {
    try {
      return (typeof window !== 'undefined' && window.localStorage.getItem(THEME_KEY)) || 'light';
    } catch {
      return 'light';
    }
  });

  useEffect(() => {
    document.documentElement.setAttribute('data-theme', theme);
    try {
      window.localStorage.setItem(THEME_KEY, theme);
    } catch {}
  }, [theme]);

  const setTheme = (value) => {
    setThemeState(typeof value === 'function' ? value(theme) : value);
  };

  return (
    <ThemeContext.Provider value={{ theme, setTheme, isDark: theme === 'dark' }}>
      {children}
    </ThemeContext.Provider>
  );
};

export const useTheme = () => {
  const ctx = useContext(ThemeContext);
  if (!ctx) {
    return { theme: 'light', setTheme: () => {}, isDark: false };
  }
  return ctx;
};
